import { BrowserRouter as Router, Routes, Route, Link, NavLink, useNavigate, Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import Perfil from './Perfil';
import Publicaciones from './Publicaciones';
import AdminPanel from './AdminPanel';
import Publicar from './Publicar';
import './App.css';
import { useState, useEffect } from 'react';
import { auth, db } from './firebaseConfig';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, setDoc, increment } from 'firebase/firestore';
import logo from './logo.png';
import SplashScreen from './SplashScreen';
import SubirHistoriaPage from './SubirHistoriaPage';
import VerificacionEdad from './VerificacionEdad';
import AuthForm from './AuthForm';
import Header from './Header';
import Footer from './Footer';
import TerminosCondiciones from './TerminosCondiciones';
import SEO from './SEO';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [onlineUsers, setOnlineUsers] = useState(0);
  const [verificado, setVerificado] = useState(() => {
    return localStorage.getItem('mayorDe18') === 'true';
  });

  // ✅ Detectar si es admin desde claims
  useEffect(() => {
    // 1. Estadísticas de Visitas Diarias
    const trackVisit = async () => {
      // const hasVisited = sessionStorage.getItem('visited_today'); // DESACTIVADO para garantizar conteo real inmediato
      // if (!hasVisited) {
      try {
        const today = new Date();
        const dateStr = today.toISOString().split('T')[0]; // YYYY-MM-DD
        const docRef = doc(db, 'stats_daily', dateStr);

        await setDoc(docRef, {
          visits: increment(1),
          date: today // Guardar fecha para ordenar
        }, { merge: true });

        sessionStorage.setItem('visited_today', 'true');
      } catch (error) {
        console.error("Error tracking daily visit:", error);
      }
      // }
    };
    trackVisit();

    // 2. Auth Listener
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser && !firebaseUser.isAnonymous) {
        const tokenResult = await firebaseUser.getIdTokenResult();
        const isAdmin = !!tokenResult.claims.admin;
        setUser({
          uid: firebaseUser.uid,
          email: firebaseUser.email,
          displayName: firebaseUser.displayName,
          photoURL: firebaseUser.photoURL,
          isAdmin,
        });
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (user) {
      console.log("👤 Usuario con claims:", user);
    }
  }, [user]);

  // 3. Simulador de Usuarios Online (Engagement)
  useEffect(() => {
    const baseUsers = Math.floor(Math.random() * 20) + 5; // Usuarios reales base (simulado)
    const randomBoost = Math.floor(Math.random() * 100) + 1; // Boost solicitado (1-100)
    setOnlineUsers(baseUsers + randomBoost);

    const interval = setInterval(() => {
      setOnlineUsers(prev => {
        const change = Math.floor(Math.random() * 5) - 2; // -2 a +2
        return Math.max(baseUsers, prev + change);
      });
    }, 5000); // Actualizar cada 5s

    return () => clearInterval(interval);
  }, []);



  const logout = () => {
    signOut(auth);
    setUser(null);
  };

  /* login function removed as it was unused and replaced by AuthForm */

  const aceptarEdad = () => {
    localStorage.setItem('mayorDe18', 'true');
    setVerificado(true);
  };

  if (!verificado) return <VerificacionEdad onAceptar={aceptarEdad} />;
  if (loading) return <SplashScreen />;

  return (
    <Router>
      <div className="bg-black min-h-screen text-white flex flex-col">
        {/* HEADER */}
        {/* HEADER */}
        <Header user={user} logout={logout} onlineUsers={onlineUsers} />

        {
          user && (
            <div className="bg-neutral-900 text-xs text-center py-2 text-gray-400 border-b border-white/5 animate-fade-in">
              👋 Conectado como: <span className="text-white font-medium ml-1">{user.email}</span>
              {user.isAdmin && (
                <Link to="/admin" className="ml-2 text-yellow-500 font-bold text-[10px] uppercase tracking-wider bg-yellow-500/10 px-2 py-0.5 rounded-full border border-yellow-500/20 hover:bg-yellow-500/20 transition-colors">
                  Administrador
                </Link>
              )}
            </div>
          )
        }

        <div className="max-w-6xl mx-auto p-4">
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <SEO
                    title="Inicio"
                    description="VipEncuentros es el sitio #1 de scorts masculinos y hombres en Santiago. Encuentra tu chico ideal, activo o pasivo, discreto y real."
                    keywords="scort masculino, sexo, hombres, masajistas, gay, escort, santiago, chile, encuentros, xxx, masajes eroticos, chicos, acompañantes"
                  />
                  <h2 className="text-lg font-semibold mb-4 text-gray-200">
                    Scorts masculinos, hombres para sexo y masajistas en Santiago
                  </h2>
                  <p className="text-xs text-neutral-500 mb-6 leading-relaxed">
                    ¿Buscas un scort o masajes relajantes? Encuentra chicos reales y discretos aquí.
                  </p>
                  <Publicaciones />
                </>
              }
            />
            <Route
              path="/admin"
              element={
                user && user.isAdmin ? (
                  <div className="mt-4">
                    <Link to="/" className="text-sm text-gray-500 hover:text-white mb-4 inline-block">&larr; Volver al Inicio</Link>
                    <AdminPanel isAdmin={true} user={user} />
                  </div>
                ) : (
                  <Navigate to="/" replace />
                )
              }
            />
            <Route path="/perfil/:id" element={<Perfil />} />
            <Route path="/publicar" element={<Publicar user={user} />} />
            <Route path="/subir-historia" element={<SubirHistoriaPage />} />
            <Route path="/login" element={<AuthPage />} />
            <Route path="/terminos-condiciones" element={<TerminosCondiciones />} />
          </Routes>
        </div>
        <Footer />
      </div >
    </Router >
  );
}

function AuthPage() {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);

  if (user && !user.isAnonymous) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-[80vh] flex items-center justify-center py-10 animate-fade-in">
      <SEO
        title="Ingresar | VipEncuentros"
        description="Ingresa a tu cuenta en VipEncuentros para gestionar tu perfil y publicaciones."
        url="https://vipencuentros.com/login"
      />
      <div className="w-full max-w-sm">
        <AuthForm onSuccess={() => navigate('/')} />
      </div>
    </div>
  );
}

export default App;
